var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19064 4.16754C7.73035 2.93578 9.68346 2.19922 11.8086 2.19922C16.7792 2.19922 20.8086 6.22866 20.8086 11.1992C20.8086 13.3244 20.072 15.2775 18.8403 16.8172L6.19064 4.16754ZM4.77648 5.5818C3.54498 7.12143 2.80859 9.07433 2.80859 11.1992C2.80859 16.1698 6.83803 20.1992 11.8086 20.1992C13.9335 20.1992 15.8864 19.4628 17.426 18.2313L4.77648 5.5818ZM11.8086 0.199219C5.73346 0.199219 0.808594 5.12409 0.808594 11.1992C0.808594 17.2744 5.73346 22.1992 11.8086 22.1992C17.8837 22.1992 22.8086 17.2744 22.8086 11.1992C22.8086 5.12409 17.8837 0.199219 11.8086 0.199219Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlash);
export default __webpack_public_path__ + "static/media/slash.0ab4d572.svg";
export { ForwardRef as ReactComponent };